import { useTranslation } from "next-i18next";
import { Button, ButtonProps } from "src/components-mui/base/button/button";
import { useLinkBuilder } from "src/hooks/use-link-builder";

interface IGoToWikifolioButtonProps extends ButtonProps {
    symbol?: string;
    href?: string;
    target?: string;
}

export const GoToWikifolioButton = ({ symbol, onClick, href, target, ...buttonProps }: IGoToWikifolioButtonProps) => {
    const { buildWikifolioLink } = useLinkBuilder();
    const { t } = useTranslation("common");
    const link = href ?? (symbol && buildWikifolioLink(symbol));

    return (
        <Button href={link} target={target} onClick={onClick} {...buttonProps}>
            {t("to-wikifolio")}
        </Button>
    );
};
